import React from 'react'
import { useGlobalStore } from '~/stores/store-provider'
import { extractHtmlAssetsFromMessages } from '~/lib/utils/asset-extraction'

interface AssetSelectorModalProps {
  isOpen: boolean
  onClose: () => void
  onAssetSelected: (sessionId: string, filename: string, title: string) => void
  sessionId: string
}

const AssetSelectorModal: React.FC<AssetSelectorModalProps> = ({ 
  isOpen, 
  onClose, 
  onAssetSelected,
  sessionId 
}) => {
  const { chatMessages } = useGlobalStore((state: any) => state)
  
  const availableAssets = extractHtmlAssetsFromMessages(chatMessages)

  const handleAssetSelect = (asset: any) => {
    onAssetSelected(asset.sessionId, asset.filename, asset.title)
    onClose()
  }

  if (!isOpen) return null

  return (
    <div className="modal modal-open">
      <div className="modal-box max-w-2xl">
        <h3 className="font-bold text-lg mb-4">Select Chart</h3>

        {availableAssets.length === 0 ? (
          <div className="flex flex-col items-center justify-center gap-4 py-12">
            <div className="text-base-content/50">
              <svg className="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <div className="text-center">
              <p className="text-lg font-semibold text-base-content">No charts available</p>
              <p className="text-sm mt-1 text-base-content/70">Generate charts in your conversation to add them here</p>
            </div>
          </div>
        ) : (
          <div className="space-y-2 max-h-96 overflow-y-auto pr-2">
            {availableAssets.map((asset, index) => (
              <div 
                key={`${asset.sessionId}-${asset.filename}-${index}`}
                className="card card-compact bg-base-100 border border-base-300 hover:bg-base-200 transition-colors"
              >
                <div className="card-body flex-row items-center justify-between">
                  <div className="flex-1 min-w-0">
                    <h4 className="font-semibold text-base-content truncate">
                      {asset.title}
                    </h4>
                    <p className="text-sm text-base-content/60 font-mono mt-1">
                      {asset.filename}
                    </p>
                  </div>
                  <button 
                    className="btn btn-primary btn-sm ml-4"
                    onClick={() => handleAssetSelect(asset)}
                  >
                    Select
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="modal-action">
          <button 
            className="btn btn-ghost" 
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default AssetSelectorModal